import HomeIcon from '@mui/icons-material/Home';
import { Box, Grid, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { login } from '../../api';
import logo from '../../assets/images/exsecurelogo.png';
import './styles.scss';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

const Signin = () => {
    const [message, setMessage] = useState()
    const cookie = new Cookies()
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            username: '',
            password: '',
        },
        onSubmit: () => {
            const username = formik.values.username
            const password = formik.values.password;
            const func = login(username, password)
            if (username === "" && password === "") {
                navigate('/signin');
            } else {
                func.then(async (response) => {
                    if (response.success) {
                        cookie.set('token', response.token, { path: '/' })
                        cookie.set('firstname', response.data.firstName, { path: '/' })
                        cookie.set('lastname', response.data.lastName, { path: '/' })
                        cookie.set('username', response.data.username, { path: '/' })
                        cookie.set('id', response.data._id, { path: '/' })
                        navigate('/');
                    } else {
                        setMessage('User not found')
                    }
                })
            }

        }
    })
    return (
        <Box className='signinWrapper'>
            <form onSubmit={formik.handleSubmit}>
                <Grid container>
                    <Grid item md={6} xs={12}>
                        <Box padding='16px'>
                            <Typography variant='h3' sx={{ mt: 3, mb: 2, textAlign: "center" }}>
                                {/* <img src={logo} width={70} height={70} alt='footer-logo' /> */}
                                AllinSecurity
                            </Typography>
                            <label htmlFor="username" >Username</label>
                            <input
                                type="text"
                                placeholder="Email or Phone"
                                id="username"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.username || ''}
                            />
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                placeholder="Password"
                                id="password"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.password || ''}
                            />
                            <button type="submit">Log In</button>
                        </Box>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Box sx={{ display: "flex", alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column' }}>
                            <h2 style={{ textAlign: 'center', color: '#2a9d8f', fontWeight: "bold" }}>Ready to Get Started? Log In</h2>
                            <Link to='/' style={{ color: 'black' }}>
                                Back Home <KeyboardDoubleArrowRightIcon color='black' />
                            </Link>
                        </Box>
                    </Grid>
                </Grid>


            </form>
        </Box>
    )
}

export default Signin